import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IShelterInformation } from '../models/shelterInformation';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class ShelterInformationService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getShelterInformation(buildingId: string): Observable<{has_error: boolean, message: string, data: IShelterInformation}> {
        const url = environment.apiBaseUrl + endpoints.getShelterInformation.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: IShelterInformation}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateShelterInformation(buildingId: string, data: Partial<IShelterInformation>): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateShelterInformation.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
